import { filter } from "core-js/fn/array";
import moment from 'moment';
// const XLSX = require('xlsx');
const XLSX = require('xlsx')

var methods={

  capitalize(s){
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  },
  toCapitalizedWords(name){
    var words = name.match(/[A-Za-z1-9][a-z]*/g) || [];
    return words.map(this.capitalize).join(" ");
  },
  deleteChild (array , childToDelete) {
    if(!Array.isArray(childToDelete)) childToDelete = [childToDelete]
    let newArr = JSON.parse(JSON.stringify(array));
    newArr.forEach(element => {
      // element[childToDelete] = null
      for(var i = 0 ; i < childToDelete.length ; i++) {
        delete element[childToDelete[i]];
      }
    });
    return newArr
  },
  exportExcel(data, title , tab = "Data") {
    let wb = XLSX.utils.book_new()
    let exportFileName = title ? `${title}.xlsx` : 'Exported Data.xlsx'
    var ws = XLSX.utils.json_to_sheet(data, {raw:true});
    XLSX.utils.book_append_sheet(wb, ws, tab)
    XLSX.writeFile(wb, exportFileName)
  },
  exportCsv(data, title) {
    let wb = XLSX.utils.book_new()
    let exportFileName = title ? `${title}.csv` : 'Exported Data.csv'
    var ws = XLSX.utils.json_to_sheet(data, {raw:true});
    XLSX.utils.book_append_sheet(wb, ws, 'Data')
    XLSX.writeFile(wb, exportFileName)
  },
  errorPrint(errorMessage){//PRINTS ERROR IN RED COLOR
    var error = "%c" + errorMessage;
    console.log(error, 'color:#ff0000')
  },
  errorSwal(message){
    this.$swal.fire({
      'title' : 'Error!',
      'text' : message,
      'icon' : 'error'
    })
  },
  printTest(){//PRINTS THE WORD 'TEST'
    console.log("test");
  },
  isMobile(){
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      return true;
    } else {
      return false;
    }
  },
  isRTL () {
    return document.documentElement.getAttribute('dir') === 'rtl' || document.body.getAttribute('dir') === 'rtl'
  },
  numberWithCommas(x) {
    return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  randomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
  },
  randomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  },
  initialiseFilter (filterString, filterObj) {
    let keys = Object.keys(filterObj)

    for (var i = 0; i < keys.length; i++) {
        // check if the requested filter is an empty array or null or empty string
        if ( !filterObj[keys[i]] || (typeof filterObj[keys[i]] == 'object' && filterObj[keys[i]].length <= 0) || filterObj[keys[i]] == '')
            continue

        else if (keys[i] == 'type') {
            let newData = filterObj[keys[i]].toUpperCase()
            filterString += `${keys[i]}=${newData}&`
        }
        else
            filterString += `${keys[i]}=${filterObj[keys[i]]}&`
    }
    // console.log(filterString)
    return filterString
  },
  transformFilter (filter) {
    let obj = {}
    let keys = Object.keys(filter)
    for (var i = 0 ; i < keys.length; i++) {
      if(keys[i] == 'start' || keys[i] == 'end' || keys[i] == 'month' || keys[i] == 'year')
        obj[keys[i]] = filter[keys[i]]
      else if(!filter[keys[i]] || filter[keys[i]] == '')
        continue
      else if (keys[i] == 'area')
        continue;
      else if (keys[i] == 'semester' || keys[i] == 'transporter' || typeof filter[keys[i]] == 'string')
        obj[keys[i]] = filter[keys[i]]
      else if (keys[i] == 'type') {
        // console.log(filter[keys[i]])
        obj[keys[i]] = filter[keys[i]].type ? filter[keys[i]].type : filter[keys[i]]

        // obj[keys[i]] ? obj[keys[i]]: ''
      }
      else if (keys[i] == 'color')
        obj[keys[i]] = filter[keys[i]].color
      else if (keys[i] == 'segment')
        obj[keys[i]] = filter[keys[i]].segment
      else if (keys[i] == 'category')
        obj[keys[i]] = filter[keys[i]].category
      else
        obj[keys[i]] = filter[keys[i]].code

    }
    return obj
  },  



  

  //Load Filter Options
  async loadFilterOptions (module) {
    var filterList = ['mainDealer', 'gudang', 'karesidenan', 'city', 'dealer', 'category', 'segment', 'subSeries', 'type', 'codeMarket', 'month', 'year', 'color','transporter']
    var urlList = ['mainDealer', 'gudang', 'karesidenan', 'city', 'dealer', 'category', 'segment', 'subSeries', 'type', 'codeMarket', 'month', 'year', 'colour', 'transporter']

    if(module != null){
      let index = filterList.indexOf(module)
      if(index != -1) {
        filterList = filterList.splice(index, 1);
        urlList = urlList.splice(index, 1);
      }
    }

    for (var i = 0 ; i < filterList.length; i++) {
      // if(this.$store.state.filterOptions[filterList[i]] == null){
        if (filterList[i] == 'month') {
          let month = []
          let monthName = ['January' , 'February' , 'March' , 'April', 'May', 'June' , 'July', 'August', 'September', 'October' , 'November', 'December']
          for (var j = 0 ; j < 12; j++) {
              month.push({
                value: j + 1,
                name: monthName[j]
              })
          }

          this.$store.dispatch('setMonth', month);
        } else if (filterList[i] == 'year') {
          let year = []
          for (var j = 2018 ; j <= new Date().getFullYear(); j++) {
              year.push(j)
          }

          this.$store.dispatch('setYear', year);
        } else {
          await this.$http.get(`/api/master/${urlList[i]}`)
          .then((resp) => {
            let data = resp.data.data;
            if(!Array.isArray(data)) return;
  
            if(filterList[i] == 'mainDealer' || filterList[i] == 'gudang' || filterList[i] == 'dealer')
            {
              
              for (var j = 0 ; j < data.length ; j ++) {
                data[j].name = `${data[j].code} - ${data[j].name}` 
              }
            } else if (filterList[i] == 'karesidenan' || filterList[i] == 'city') {
              for(var j = 0 ; j < data.length ; j++){
                data[j].name = data[j].code;
                // console.log(data[j])
              }
            } else if ( filterList[i] == 'codeMarket') {
              for (var j = 0 ; j < data.length ; j ++) {
                data[j].name = `${data[j].codeMarket} ${data[j].codeMarketName ? '- ' + data[j].codeMarketName : ''}` 
              }
            } else if ( filterList[i] == 'color') {
              for (var j = 0 ; j < data.length ; j ++) {
                if(data[j].color && data[j].colorDesc)
                  data[j].name = `${data[j].color} - ${data[j].colorDesc}`
                else if (data[j].color && !data[j].colorDesc)
                  data[j].name = `${data[j].color}`
                else {
                  // console.log(JSON.stringify(data[j]))
                  data[j].name = 'Others'
                  data[j].color = 'Others'
                }
              }
            }
  
            this.$store.dispatch(`set${this.capitalize(filterList[i])}`, data)
          })
          .catch((err) => {
            console.log(err)
          })
        }//ELSE ENDS
      }//IF ENDS
    // }//FOR LOOP ENDS
  },
  // Change Axios type to Async Await Instead of Then to provide More Consistent Result - Marv
  async loadModules(){
    try {
      let resp = await this.$http.get('/api/master/modules')

      let obj = []
      for (var i = 0 ; i < resp.data.data.length ; i++) {
        let data = resp.data.data[i]

        // Keep raw API name for access pickers; title is normalized for navigation
        data.moduleName = data.name;
        //Nomalize data to match MPM navigation style
        if (data.name === 'Penerimaan QR Dealer' || data.name === 'Penerimaan QR dealer') {
          data.name = 'Penerimaan QR';
        }
        data.title = data.name;
        delete data.name;
        if (data.link) data.path = data.link;
        delete data.link;
        
        if(data.parent_id) {
          let parent = resp.data.data.find(x => x.id == data.parent_id)
          !parent.children ? parent.children = [data] : parent.children.push(data)  
        }
        else obj.push(data)

        delete data.parent_id
        delete data.parent_name
        !data.icon ? delete data.icon : '';
      }

      this.$store.state.modules = obj;
      return obj
    }
    catch(err) {
      console.log(err)
    }
    

  },
}

export default methods;